// ========================================
// COMPONENTS / Footer.jsx — Moon Berry
// ========================================

import React, { useState, useEffect } from "react";
import styles from "./Footer.module.css";

const SHOP_LINKS = ["All Products", "By Occasion", "New Arrivals"];

const HELP_LINKS = [
  "Shipping & Delivery",
  "Returns & Refunds",
  "Terms & Conditions",
  "Privacy Policy",
  "FAQs",
];

function IconInstagram() {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" width="20" height="20">
      <rect x="2" y="2" width="20" height="20" rx="5" ry="5"/>
      <circle cx="12" cy="12" r="4"/>
      <circle cx="17.5" cy="6.5" r="1" fill="currentColor" stroke="none"/>
    </svg>
  );
}
function IconFacebook() {
  return (
    <svg viewBox="0 0 24 24" fill="currentColor" width="20" height="20">
      <path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z"/>
    </svg>
  );
}
function IconWhatsApp() {
  return (
    <svg viewBox="0 0 24 24" fill="currentColor" width="20" height="20">
      <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 0 1-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 0 1-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 0 1 2.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0 0 12.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 0 0 5.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 0 0-3.48-8.413z"/>
    </svg>
  );
}
function IconTikTok() {
  return (
    <svg viewBox="0 0 24 24" fill="currentColor" width="20" height="20">
      <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-2.88 2.5 2.89 2.89 0 0 1-2.89-2.89 2.89 2.89 0 0 1 2.89-2.89c.28 0 .54.04.79.1V9.01a6.34 6.34 0 0 0-.79-.05 6.34 6.34 0 0 0-6.34 6.34 6.34 6.34 0 0 0 6.34 6.34 6.34 6.34 0 0 0 6.33-6.34V8.69a8.17 8.17 0 0 0 4.78 1.52V6.76a4.85 4.85 0 0 1-1.01-.07z"/>
    </svg>
  );
}
function IconAmazon() {
  return (
    <svg viewBox="0 0 24 24" fill="currentColor" width="20" height="20">
      <path d="M13.958 10.09c0 1.232.029 2.256-.591 3.351-.502.891-1.301 1.438-2.186 1.438-1.214 0-1.922-.924-1.922-2.292 0-2.692 2.415-3.182 4.699-3.182v.685zm3.186 7.705c-.209.189-.512.201-.748.074-1.052-.874-1.241-1.279-1.814-2.111-1.733 1.767-2.96 2.297-5.209 2.297-2.66 0-4.731-1.641-4.731-4.925 0-2.565 1.391-4.309 3.37-5.164 1.715-.754 4.11-.891 5.942-1.099v-.41c0-.753.06-1.642-.384-2.294-.385-.581-1.124-.821-1.775-.821-1.205 0-2.277.618-2.54 1.897-.054.285-.261.567-.549.582l-3.061-.33c-.259-.057-.545-.267-.472-.664C5.855 2.354 8.73 1.5 11.28 1.5c1.307 0 3.015.348 4.045 1.338 1.307 1.224 1.183 2.854 1.183 4.629v4.192c0 1.261.522 1.813 1.013 2.492.174.243.211.536-.007.716l-2.37 2.028zm2.876 2.43C17.6 22.5 13.8 24 10.6 24c-4.585 0-8.717-1.697-11.84-4.525-.245-.221-.027-.524.269-.352 3.369 1.958 7.53 3.138 11.832 3.138 2.902 0 6.093-.601 9.027-1.851.443-.189.812.29.432.815z"/>
    </svg>
  );
}
function IconNoon() {
  return (
    <img src="/Noon icon.png" alt="Noon" style={{ width: 26, height: 26, objectFit: "cover", borderRadius: "50%" }} />
  );
}
function IconDeliveroo() {
  return (
    <img src="/Deliveroo-2.png" alt="Deliveroo" style={{ width: 22, height: 22, objectFit: "contain" }} />
  );
}

const SOCIAL_LINKS = [
  { label: "Instagram", Icon: IconInstagram, href: "https://www.instagram.com/moon_berry593?igsh=eGJ1NnVicnhqOHJp&utm_source=qr" },
  { label: "Facebook",  Icon: IconFacebook,  href: "https://www.facebook.com/share/1EukKETPGY/?mibextid=wwXIfr" },
  { label: "TikTok",    Icon: IconTikTok,    href: "https://www.tiktok.com/@moonberry527?_r=1&_t=ZS-96pJ7odqGOe" },
  { label: "Amazon",    Icon: IconAmazon,    href: "https://www.amazon.ae/s?me=A3QSUWER4MXFQ6&marketplaceID=A2VIGQ35RCS4UG" },
  { label: "Noon",      Icon: IconNoon,      href: "https://www.noon.com/en-ae/p-465610?utm_source=C1000207L&utm_medium=referral" },
  { label: "Deliveroo", Icon: IconDeliveroo, href: "https://deliveroo.ae/menu/dubai/damac-hills/moon-berry?utm_campaign=organic&utm_medium=referrer&utm_source=menu_share" },
];

function PhoneIcon() {
  return (
    <svg viewBox="0 0 24 24" fill="currentColor" width="16" height="16">
      <path d="M6.62 10.79a15.05 15.05 0 0 0 6.59 6.59l2.2-2.2a1 1 0 0 1 1.01-.24 11.47 11.47 0 0 0 3.59.57 1 1 0 0 1 1 1V20a1 1 0 0 1-1 1A17 17 0 0 1 3 4a1 1 0 0 1 1-1h3.5a1 1 0 0 1 1 1c0 1.25.2 2.45.57 3.59a1 1 0 0 1-.25 1.01l-2.2 2.2z"/>
    </svg>
  );
}
function MailIcon() {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" width="16" height="16">
      <rect x="2" y="4" width="20" height="16" rx="2"/>
      <polyline points="2,4 12,13 22,4"/>
    </svg>
  );
}
function PinIcon() {
  return (
    <svg viewBox="0 0 24 24" fill="currentColor" width="16" height="16">
      <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5a2.5 2.5 0 1 1 0-5 2.5 2.5 0 0 1 0 5z"/>
    </svg>
  );
}

export default function Footer() {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  useEffect(() => {
    const handler = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener("resize", handler);
    return () => window.removeEventListener("resize", handler);
  }, []);

  const footerBg = isMobile ? "url('/footermobilebg.png')" : "url('/footerbg.png')";
  return (
    <footer className={styles.footer}>

      {/* ── Full footer with bg image ── */}
      <div className={styles.content} style={{ backgroundImage: footerBg }}>

        {/* Three columns */}
        <div className={styles.columns}>
          {/* SHOP */}
          <div className={styles.col}>
            <div className={styles.colTitle}>SHOP</div>
            {SHOP_LINKS.map((link) => (
              <a key={link} href="#" className={styles.colLink}>{link}</a>
            ))}
          </div>

          {/* HELP */}
          <div className={styles.col}>
            <div className={styles.colTitle}>HELP</div>
            {HELP_LINKS.map((link) => (
              <a key={link} href="#" className={styles.colLink}>{link}</a>
            ))}
          </div>

          {/* CONTACT US */}
          <div className={styles.col}>
            <div className={styles.colTitle}>CONTACT US</div>
            <p className={styles.contactDesc}>
              We'd love to hear from you! At Moon Berry, we're always happy to
              help with your questions, orders, or custom gift inquiries.
            </p>
            <div className={styles.contactItem}>
              <span className={styles.contactIcon}><PhoneIcon /></span>
              <span>+971 567 475 975</span>
            </div>
            <div className={styles.contactItem}>
              <span className={styles.contactIcon}><MailIcon /></span>
              <span>moonberry593@gmail.com</span>
            </div>
            <div className={styles.contactItem}>
              <span className={styles.contactIcon}><PinIcon /></span>
              <span>Dubai, UAE</span>
            </div>
          </div>
        </div>

        {/* Divider */}
        <div className={styles.hr} />

        {/* Bottom bar */}
        <div className={styles.bottom}>
          <div className={styles.socials}>
            {SOCIAL_LINKS.map(({ label, Icon, href }) => (
              <a
                key={label}
                href={href}
                target="_blank"
                rel="noopener noreferrer"
                className={styles.socialBtn}
                aria-label={label}
                style={{}}
              >
                <Icon />
              </a>
            ))}
          </div>
          <div className={styles.copyright}>
            © 2026 Moon Berry. All Rights Reserved.
          </div>
          <div className={styles.tagline}>
            Made with <span className={styles.heart}>♥</span> for every special moment
          </div>
        </div>

      </div>
    </footer>
  );
}
